import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} userIds
 */
export const excelExportAllUsersService = () =>
  new Request(URL.REPORT_API, URL.EXCEL_EXPORT_ALL_USERS).post({})

/**
 *
 */
export const shopListService = () => new Request(URL.API, URL.SHOP_LIST).get()

/**
 *
 * @param {*} code
 */
export const appsumoCodeService = code =>
  new Request(URL.API, URL.APPSUMO_CODE_CONFIRM).post({ code })

/**
 *
 * @param {*} promoCodes
 */
export const appsumoCouponRefundService = promoCodes =>
  new Request(URL.API, URL.APPSUMO_CODE_REFUND).post({ promoCodes })

/**
 *
 * @param {*} Type
 */
export const getLocalizationStringOfTypeService = type =>
  new Request(URL.API, URL.GET_LOCALIZATION_STRING_OF_TYPE + `${type}`).get()

export const aiTextGenerator = prompt =>
  new Request(URL.API, URL.AI_TEXT_GENERATOR).post({ prompt })
